var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var StateVariableDeclaration = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var doc = concat(path.map(function (statementPath) {
      if (!statementPath.getValue()) {
        return ', ';
      }

      return _print(statementPath);
    }, 'variables'));

    if (node.initialValue) {
      doc = concat([doc, ' = ', path.call(_print, 'initialValue')]);
    }

    return concat([doc, ';']);
  }
};
module.exports = StateVariableDeclaration;